import React, { Component } from 'react';
import { TEXT } from '../../../../../../../content';
import './Comment.css';
import { msToTimeString } from '../../../../../../../utils';

class Comment extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { onVideoSeek, data } = this.props;
    onVideoSeek(false, data.time);
  }

  render() {
    const { data } = this.props;
    const { time, name, msg } = data;

    const parsedName = name.length === 0 ? TEXT.NAME_PLACEHOLDER : name;

    return (
      <div className="comment-message">
        <span className="comment-title">
          {`${parsedName} | `}
          <button type="button" onClick={this.handleClick}>
            {msToTimeString(time)}
          </button>
          {` |`}
        </span>
        {` ${msg}`}
      </div>
    );
  }
}

export default Comment;



// WEBPACK FOOTER //
// ./src/components/App/Okupace/Content/Detail/Discussion/Comment/Comment.js